module.exports = __webpack_public_path__ + "static/media/sendicon.90a8e0bf.png";